import React, { useMemo } from "react";
import Dashboard from "components/dashboard";
import { PageHeaderBar, PageSection } from "components/page";
import { useQuery, QueryResponseHandler } from "components/graphql";
import { RecordingData, getRecordingQuery, RecordingFileData } from "./details-page";
import { useCurrentCustomerContext } from "components/current-customer-context";
import { useAuthDataContext } from "components/auth";
import { eventStatusTypes } from "pages/event";
import { FormattedMessage } from "react-intl";
import ShakaPlayerComponent from "../../components/shaka-player/ShakaPlayerComponent";
import VideoPosterDefault from "static/images/video-poster-default.png";

const RecordingDetailsPage = ({
  match: {
    params: { id },
  },
}) => {

  const ref = React.useRef(null);
  const { hasAdminPrivileges } = useAuthDataContext();
  const { currentCustomerId } = useCurrentCustomerContext();
  const query = useMemo(
    () => getRecordingQuery({ recordingId: id, customerId: currentCustomerId, hasAdminPrivileges }),
    [id, currentCustomerId, hasAdminPrivileges],
  );
  const { data, loading, error } = useQuery(query);

  const recording = data.recording;
  const files = recording ? recording.availableFiles : [];


  const blockAccess =
    recording &&
    recording.event &&
    recording.event.eventStatus &&
    recording.event.eventStatus === eventStatusTypes.STARTED;

  return (
    <Dashboard>
      <QueryResponseHandler error={error} loading={loading} elements={recording}>
        <PageHeaderBar
          showBackButton
          title="app.page.recording.details.title"
          titleParams={{ recordingName: recording ? recording.description : null }}
        />
        <PageSection>
          {!blockAccess && <RecordingData recording={recording} />}
          {blockAccess && <FormattedMessage id="recording.blocked" />}
        </PageSection>
        {!blockAccess && files && (
          <>
            <PageHeaderBar subtitle title="app.page.recordingfile.list" />
            <PageSection hideBackground>
              {files.map(file => (
                <PageSection key={file.url} spaced>
                  <RecordingFileData recording={recording} recordingFile={file} />
                  <ShakaPlayerComponent ref={ref} autoPlay src={file.url} poster={VideoPosterDefault} />
                </PageSection>
              ))}
            </PageSection>
          </>
        )}
      </QueryResponseHandler>
    </Dashboard>
  );
};

export default RecordingDetailsPage;
